export default __webpack_public_path__ + "static/media/e-invoicing.1aedc12f.svg";